import { bool, object } from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import asyncTradeRewardsNav from './asyncTradeRewardsNav';

class Rewards extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            RewardsNav: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (!get(prevProps, 'user.isVerifiedTrade') && get(this.props, 'user.isVerifiedTrade')) {
            asyncTradeRewardsNav().then(RewardsNav => {
                this.setState({ RewardsNav });
            });
        }
    }

    render() {
        const { RewardsNav } = this.state;
        const { hasUser, hasUserId, isClient, user, viewer } = this.props;
        const isVerifiedTrade = get(user, 'isVerifiedTrade');

        if (!isClient || (hasUserId && !hasUser) || !isVerifiedTrade || !RewardsNav) {
            return null;
        }

        return <RewardsNav viewer={viewer} user={user} />;
    }
}

Rewards.propTypes = {
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    user: object,
    viewer: object,
};

export default createFragmentContainer(Rewards, {
    viewer: graphql`
        fragment Rewards_viewer on Viewer {
            ...RewardsNav_viewer
        }
    `,
    user: graphql`
        fragment Rewards_user on User {
            ...RewardsNav_user
            isVerifiedTrade
        }
    `,
});
